import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '14.0701 3.2301'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M23.9999 1.36011C23.9999 1.36011 20.6799 2.58011 14.2599 2.58011C7.83986 2.58011 4.12988 1.36011 4.12988 1.36011C4.12988 1.36011 7.57988 5.65012 14.0599 5.65012C20.5399 5.65012 23.9999 1.36011 23.9999 1.36011Z"
          fill="white"
          stroke={outline}
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M27.2701 0.810059C27.1401 1.46006 26.4801 1.94006 25.8101 2.06006C25.4701 2.14006 25.1301 2.13006 24.8001 2.09006C24.4701 2.05006 24.1601 1.96008 23.8601 1.83008L24.1801 1.84006C22.5001 2.30006 20.8401 2.57008 19.1501 2.77008C17.4701 2.96008 15.7701 3.06007 14.0801 3.07007C12.3901 3.08007 10.6901 2.98008 9.00012 2.80008C7.31012 2.60008 5.65012 2.33007 3.97012 1.85007L4.2901 1.84006C4.0101 2.00006 3.69011 2.11006 3.36011 2.16006C3.02011 2.20006 2.68011 2.21009 2.33011 2.12009C1.65011 1.97009 1.00012 1.47007 0.870117 0.820068C1.42012 1.15007 1.9401 1.20006 2.4201 1.16006C2.9101 1.12006 3.38011 0.980085 3.93011 0.900085L4.1701 0.870087L4.2601 0.900085C5.8001 1.34009 7.4701 1.62006 9.1001 1.81006C10.7501 1.99006 12.4001 2.09008 14.0601 2.08008C15.7201 2.07008 17.3801 1.98007 19.0201 1.79007C20.6601 1.60007 22.3201 1.32009 23.8701 0.900085L23.9901 0.870087L24.1801 0.910065L24.9501 1.12009C25.2001 1.16009 25.4501 1.22006 25.7001 1.22006C26.2101 1.21006 26.7201 1.14006 27.2701 0.810059Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
